module.exports = __webpack_public_path__ + "img/FRONT-01.9a806ee9.png";